import moment from 'moment-timezone'

function load () {
  moment.tz.setDefault('America/Sao_Paulo')
  moment.locale('pt')
}

export default { load }



// WEBPACK FOOTER //
// ./src/config/moment.js